import { staticTable } from "@-/dev.improve.haniverse.database.schemas.static._lib.table";
import { index, integer, text } from "@-/dev.improve.haniverse.lib.database.table";

export const wordTable = staticTable(
  "word",
  {
    /** The graphemes that make up the word */
    word: text("word").notNull(),

    // NOTE: keep `min_rank` AFTER `word`. The haniverse-worker deploy loads static.db into D1 with
    // a positional `sqlite3 .dump`, so the column order created from this schema must match D1's.
    // This index was added to D1 via `ALTER TABLE ADD` (appended), so any column introduced after
    // the initial migration must be declared at the end here too.
    //
    // Pre-aggregated best (smallest) SUBTLEX rank across every `word_subtlex` row whose
    // `word_id` joins to this word. Populated by the static-DB build (stage2). Lets the Browse
    // frequency view sort+paginate directly on `word.min_rank` instead of a `MIN(rank) GROUP BY
    // word` over the full `word_subtlex` table.
    minRank: integer("min_rank"),
  },
  (table) => [index("word_word_idx").on(table.word), index("word_min_rank_idx").on(table.minRank)],
);

export type Word = typeof wordTable.$inferSelect;
